// @flow
export { default } from './CategoryEditItemList';



// WEBPACK FOOTER //
// ./src/components/write/CategoryEditItemList/index.js